import React, { useState, useEffect } from 'react';
import { navigationMenu } from '../data/conclaveData';
import { Menu, X } from 'lucide-react';
import { filterAndSort, scrollToSection } from '../utils/dataUtils';
import { useModal } from '../context/ModalContext';

import STTClogo from '../media/uploads/STTClogo.png';
import SKL_Logo_white from '../media/uploads/SKL_Logo_white.png';
import CSIheader from '../media/uploads/CSI_newheader.png';

export default function Header({ setInvolvedIndex }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  const visibleMenuItems = filterAndSort(navigationMenu);
  const getInvolved = { id: 'get-involved' };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      let matchedSection = null;

      for (const item of visibleMenuItems) {
        const section = document.getElementById(item.id);
        if (section) {
          const { offsetTop, offsetHeight } = section;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            matchedSection = item.id;
            break;
          }
        }
      }

      if (matchedSection && matchedSection !== activeSection) {
        setActiveSection(matchedSection);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, [visibleMenuItems]);

  const handleNavClick = (item) => {
    if (item.isRoute) {
      window.location.href = item.id;
    } else {
      scrollToSection(item.id);
      setActiveSection(item.id);
      if (item.id === 'get-involved') {
        setInvolvedIndex(0);
      }
    }
    setIsMenuOpen(false);
  };


  const { openModal } = useModal();
    const handleClick = () => {
      openModal('delegates')
    };


  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 ${
        isScrolled ? 'backdrop-blur-[30px] bg-[#0F0D2B]/20 shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1728px] w-full mx-auto px-4 md:px-10 py-4 md:py-6 flex items-center justify-between overflow-hidden">
        
        {/* Left: Logo */}
        <div className="md:w-[14.3%] flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
          <img src={STTClogo} alt="STTC Logo" className="w-10 md:w-14" />
        </div>

        {/* Center Navigation (Desktop Only) */}
        <div className="md:w-[72%] hidden lg:flex justify-center flex-1">
          <div className="glass-effect-strong backdrop-blur-xl rounded-full px-3 py-2 border border-white/5 shadow-2xl">
            <div className="flex flex-nowrap items-center">
              {visibleMenuItems.map((item) => (
                <div key={item.id} className="relative">
                  <button
                    onClick={() => handleNavClick(item)}
                    className={`px-5 py-3 text-sm font-medium mx-1 whitespace-nowrap relative ${
                      activeSection === item.id
                        ? 'text-white font-semibold'
                        : 'text-white/70 hover:text-white hover:bg-white/10'
                    }`}
                  >
                    {item.label}
                    {activeSection === item.id && (
                      <span className="block mx-auto mt-1 h-[2px] w-4/5 rounded-full bg-gradient-to-r from-[#EA5133] to-[#5744B1]" />
                    )}
                  </button>
                </div>
              ))}
              {/* <button
                className="ml-3 whitespace-nowrap text-white px-6 py-2 rounded-full btn-background"
                onClick={() => handleNavClick(getInvolved)}
              >
                Register
              </button> */}
                {/* <button className="ml-3 whitespace-nowrap text-white px-6 py-2 rounded-full btn-background"
                      onClick={handleClick}
                    >
                      Claim Your Spot
                    </button> */}
            </div>
          </div>
        </div>

        {/* Right Logos (Desktop Only) */}
        <div className="hidden sm:flex items-center justify-end gap-4 ml-4 flex-shrink-0 overflow-hidden">
          <a href="https://www.csi-india.org/" target="_blank" rel="noopener noreferrer">
            <img src={CSIheader} className="h-10 md:h-12 object-contain" alt="CSI Logo" />
          </a>
          <div className="w-[3px] h-10 md:h-12 bg-gradient-to-b from-[#ea5133] to-[#5744b1]" />
          <a href="https://www.skillablers.com/" target="_blank" rel="noopener noreferrer">
            <img src={SKL_Logo_white} className="h-12 md:h-14 object-contain -translate-y-1" alt="SKL Logo" />
          </a>
        </div>

        {/* Mobile Menu Icon */}
        <div className="lg:hidden ml-auto">
          <button
            className="text-white bg-[#1a1b3e]/90 backdrop-blur-xl rounded-full p-3 border border-white/10 shadow-xl"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="lg:hidden fixed top-20 inset-x-0 z-40 bg-[#0F0D2B] text-white shadow-lg px-4 py-4 w-full">
          <ul className="space-y-3">
            {visibleMenuItems.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => handleNavClick(item)}
                  className={`w-full text-left text-base font-medium px-4 py-2 rounded-md ${
                    activeSection === item.id
                      ? 'bg-gradient-to-r from-[#EA5133] to-[#5744B1] text-white'
                      : 'hover:bg-white/10'
                  }`}
                >
                  {item.label}
                </button>
              </li>
            ))}
            <li>
              {/* <button
                onClick={() => handleNavClick(getInvolved)}
                className="w-full text-center mt-4 font-semibold px-6 py-3 rounded-full text-white bg-gradient-to-r from-[#EA5133] to-[#5744B1]"
              >
                Register
              </button> */}
                {/* <button className="w-full text-center mt-4 font-semibold px-6 py-3 rounded-full text-white bg-gradient-to-r from-[#EA5133] to-[#5744B1]"
                      onClick={handleClick}
                    >
                      Claim Your Spot
                    </button> */}
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
